import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ApiErrorNotification {
  message: string;
  status?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorNotificationService {
  private readonly errors: ApiErrorNotification[] = [];
  private readonly currentErrorSubject = new BehaviorSubject<ApiErrorNotification | null>(null);

  public readonly currentError = this.currentErrorSubject.asObservable();

  public show(error: ApiErrorNotification): void {
    this.errors.push(error);
    if (!this.currentErrorSubject.value) {
      this.showNext();
    }
  }

  public dismiss(): void {
    this.showNext();
  }

  private showNext(): void {
    this.currentErrorSubject.next(this.errors.shift() ?? null);
  }
}